(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["theme-scripts"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = () => document.body.dataset.root || '/';
  const cartUrl = () => document.body.dataset.cartUrl || root() + 'cart';
  const message = () => document.body.dataset.error || 'Something went wrong. Please try again.';
  const announce = text => { const el = document.querySelector('[data-global-status]'); if (el) el.textContent = text; };
  const simpleClick = event => event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
  let opener = null;
  let cartBusy = false;
  let optionController = null;
  const drawer = () => document.getElementById('CartDrawer');
  const openDialog = dialog => {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    opener = document.activeElement;
    if (!dialog.open) dialog.showModal();
    document.body.classList.add('modal-open');
    return true;
  };
  function bindDialog(dialog) {
    if (dialog.dataset.bound) return;
    dialog.dataset.bound = 'true';
    dialog.addEventListener('close', () => {
      if (!document.querySelector('dialog[open]')) document.body.classList.remove('modal-open');
      if (opener?.isConnected) opener.focus();
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
  }
  function replaceCart(html) {
    if (typeof html !== 'string' || !html.trim()) throw new Error(message());
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const newPanel = parsed.querySelector('[data-cart-panel]');
    const panel = drawer()?.querySelector('[data-cart-panel]');
    if (!newPanel || !panel) throw new Error(message());
    panel.replaceWith(newPanel);
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = newPanel.dataset.count; });
  }
  async function requestJSON(url, options = {}) {
    const response = await fetch(url, { credentials: 'same-origin', ...options });
    let result;
    try { result = await response.json(); } catch { throw new Error(message()); }
    if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : typeof result.message === 'string' ? result.message : message());
    return result;
  }
  async function refreshCart() {
    const url = new URL(root(), location.origin);
    url.searchParams.set('sections', 'cart-panel');
    const data = await requestJSON(url);
    replaceCart(data['cart-panel']);
  }
  function showCartError(text) {
    const el = drawer()?.querySelector('[data-cart-error]');
    if (el) { el.hidden = false; el.textContent = text; }
  }
  async function mutateCart(endpoint, payload, source) {
    if (cartBusy) return;
    cartBusy = true;
    source?.setAttribute('aria-busy', 'true');
    try {
      const options = payload instanceof FormData ? { method: 'POST', body: payload } : { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) };
      const result = await requestJSON(root() + endpoint, options);
      try { replaceCart(result.sections?.['cart-panel']); }
      catch { location.assign(cartUrl()); return; }
      if (document.querySelector('[data-cart-page]')) { location.assign(cartUrl()); return; }
      drawer()?.querySelector('[data-close-dialog]')?.focus();
    } catch (error) { showCartError(error.message || message()); }
    finally { cartBusy = false; source?.removeAttribute('aria-busy'); }
  }
  async function selectOption(link) {
    const section = link.closest('[data-product-section]');
    if (!section) return;
    optionController?.abort();
    const controller = new AbortController();
    optionController = controller;
    section.setAttribute('aria-busy', 'true');
    section.querySelectorAll('button[name="add"]').forEach(button => { button.disabled = true; });
    const url = new URL(link.href);
    if (url.origin !== location.origin) { location.assign(link.href); return; }
    url.searchParams.set('section_id', section.dataset.sectionId);
    try {
      const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) throw new Error(message());
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const updated = html.getElementById(section.id);
      if (!updated) throw new Error(message());
      section.replaceWith(updated);
      history.replaceState({}, '', link.href);
      const selectedLink = Array.from(updated.querySelectorAll('[data-option-id]')).find(el => el.dataset.optionId === link.dataset.optionId);
      selectedLink?.focus({ preventScroll: true });
      updatePlanPrice(updated);
      if (window.Shopify?.PaymentButton?.init) window.Shopify.PaymentButton.init();
    } catch (error) {
      if (error.name !== 'AbortError') location.assign(link.href);
    }
  }
  function updatePlanPrice(scope) {
    const select = scope.querySelector('[data-selling-plan]');
    if (!select) return;
    const price = select.selectedOptions[0]?.dataset.price;
    const priceWrapper = scope.querySelector('[data-product-price]');
    if (price && priceWrapper) {
      const el = document.createElement('div'); el.className = 'price'; el.textContent = price;
      priceWrapper.replaceChildren(el);
    }
  }
  function setupSlideshow(section) {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const slides = [...section.querySelectorAll('[data-slide]')];
    const dots = [...section.querySelectorAll('[data-slide-go]')];
    if (slides.length < 2) return;
    let index = 0;
    let timer;
    let paused = matchMedia('(prefers-reduced-motion: reduce)').matches || section.dataset.autoplay !== 'true';
    const pause = section.querySelector('[data-slide-pause]');
    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
    };
    const stop = () => { clearInterval(timer); timer = null; };
    const start = () => {
      stop();
      if (!paused && !document.hidden) timer = setInterval(() => { if (!section.isConnected) stop(); else show(index + 1); }, Math.max(4000, Number(section.dataset.interval) || 6000));
    };
    const syncButton = () => { if (pause) pause.textContent = paused ? pause.dataset.play : pause.dataset.pause; };
    dots.forEach(dot => dot.addEventListener('click', () => { show(Number(dot.dataset.slideGo)); start(); }));
    pause?.addEventListener('click', () => { paused = !paused; syncButton(); start(); });
    section.addEventListener('mouseenter', stop);
    section.addEventListener('mouseleave', start);
    section.addEventListener('focusin', stop);
    section.addEventListener('focusout', event => { if (!section.contains(event.relatedTarget)) start(); });
    document.addEventListener('visibilitychange', () => { if (section.isConnected) start(); else stop(); });
    section.addEventListener('shopify:block:select', event => { const selected = event.target.closest('[data-slide]'); if (selected) { paused = true; show(Number(selected.dataset.slide)); syncButton(); stop(); } });
    syncButton(); start();
  }
  function initialize(scope = document) {
    scope.querySelectorAll('dialog').forEach(bindDialog);
    scope.querySelectorAll('[data-slideshow]').forEach(setupSlideshow);
    scope.querySelectorAll('[data-product-section]').forEach(updatePlanPrice);
    scope.querySelectorAll('[data-address-country]').forEach(select => { if (select.dataset.default) select.value = select.dataset.default; });
    const popup = scope.querySelector('[data-newsletter-popup]');
    if (popup && !popup.dataset.scheduled && !window.Shopify?.designMode) {
      popup.dataset.scheduled = 'true';
      setTimeout(() => { if (popup.isConnected && !document.querySelector('dialog[open]')) openDialog(popup); }, Number(popup.dataset.delay) || 15000);
    }
  }
  document.addEventListener('click', async event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const close = target.closest('[data-close-dialog]');
    if (close) { close.closest('dialog')?.close(); return; }
    const step = target.closest('[data-quantity-step]');
    if (step) {
      const input = step.closest('.quantity-control')?.querySelector('input');
      if (input) { try { if (Number(step.dataset.quantityStep) > 0) input.stepUp(); else input.stepDown(); } catch {} input.dispatchEvent(new Event('change', { bubbles: true })); }
      return;
    }
    const mediaLink = target.closest('[data-media-select]');
    if (mediaLink && simpleClick(event)) {
      event.preventDefault();
      const gallery = mediaLink.closest('.product-gallery');
      gallery.querySelectorAll('[data-media-panel]').forEach(panel => { panel.hidden = panel.dataset.mediaPanel !== mediaLink.dataset.mediaSelect; panel.querySelectorAll('video').forEach(video => video.pause()); });
      gallery.querySelectorAll('[data-media-select]').forEach(link => link.classList.toggle('is-active', link === mediaLink));
      return;
    }
    const option = target.closest('[data-option-link]');
    if (option && simpleClick(event)) { event.preventDefault(); selectOption(option); return; }
    const cartLink = target.closest('[data-open-cart]');
    if (cartLink && simpleClick(event) && typeof drawer()?.showModal === 'function') {
      event.preventDefault();
      if (cartBusy) return;
      cartBusy = true;
      cartLink.setAttribute('aria-busy', 'true');
      try { await refreshCart(); openDialog(drawer()); } catch { location.assign(cartLink.href); }
      finally { cartBusy = false; cartLink.removeAttribute('aria-busy'); }
      return;
    }
    const remove = target.closest('[data-cart-remove]');
    if (remove && simpleClick(event)) {
      event.preventDefault();
      mutateCart('cart/change.js', { id: remove.dataset.lineKey, quantity: 0, sections: ['cart-panel'], sections_url: location.pathname }, remove);
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.matches('[data-drawer-cart-form]') && event.submitter?.name !== 'checkout') {
      event.preventDefault();
      const data = new FormData(form);
      data.set('sections', 'cart-panel');
      data.set('sections_url', location.pathname);
      await mutateCart('cart/update.js', data, form);
      return;
    }
    if (!form.matches('[data-product-form]')) return;
    event.preventDefault();
    if (form.dataset.busy === 'true' || form.closest('[data-product-section]')?.getAttribute('aria-busy') === 'true') return;
    const button = form.querySelector('button[name="add"]');
    const errorBox = form.querySelector('[data-product-error]');
    const data = new FormData(form);
    data.set('sections', 'cart-panel');
    data.set('sections_url', location.pathname);
    form.dataset.busy = 'true'; form.setAttribute('aria-busy', 'true');
    if (button) button.disabled = true;
    if (errorBox) errorBox.hidden = true;
    try {
      const result = await requestJSON(root() + 'cart/add.js', { method: 'POST', body: data });
      announce(document.body.dataset.added);
      try { replaceCart(result.sections?.['cart-panel']); if (!openDialog(drawer())) location.assign(cartUrl()); }
      catch { location.assign(cartUrl()); }
    } catch (error) {
      if (errorBox) { errorBox.textContent = error.message || message(); errorBox.hidden = false; }
    } finally {
      form.dataset.busy = 'false'; form.removeAttribute('aria-busy');
      if (button) button.disabled = false;
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-selling-plan]')) updatePlanPrice(event.target.closest('[data-product-section]'));
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open], .nav-dropdown[open]').forEach(el => el.removeAttribute('open'));
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => { if (event.target.querySelector('dialog[open]')) document.body.classList.remove('modal-open'); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
})();
  } catch(e) { console.error(e); }
})();

})();
